<ng-container *ngIf="isStandAloneView; else accountingMappingContent">
  <div class="padding">
    <div class="box">
      <div class="box-body">
        <h4>{{ 'ACCOUNTING.accounting_mapping' | translate }} - {{accountingPlan?.name}}
          - {{accountingPlan?.id}}
        </h4>

        <ng-container *ngTemplateOutlet="accountingMappingContentStandAlone"></ng-container>
        <footer [gp-sticky]="'bottom'" [refreshOn]="dataLoaded"
                class="p-a"
                [ngClass]="{'dker': isAccountingRuleInitialised}">
          <ng-container *ngTemplateOutlet="footerContent"></ng-container>
        </footer>
      </div>
    </div>
  </div>
</ng-container>

<gp-modal gp-modal="edit-event"
          [size]="'xl'"
          [closable]="true"
          [onSubmit]="submitVariabilities.bind(this)"
          [onCancel]="cancelVariabilitiesModalCommand.bind(this)"
          (closed)="onClosedModal()"
          #eventpopup>
  <div class="gp-modal-title">
    <h4><i class="fa fa-pen-field icon-title" aria-hidden="true"></i> {{'ACCOUNTING.VARIABILITY.title' | translate: {
      targetAccount: accountingRuleSelection?.account,
      targetAccountTransId: accountingRuleSelection?.accountName
    } }}</h4>
  </div>
  <div class="gp-modal-body clearfix">
    <p id="description-variability">{{ 'ACCOUNTING.VARIABILITY.header' | translate }}</p>
    <table class="styled-table" aria-describedby="description-variability">
      <thead>
        <tr>
          <th class="text-sm w-30">{{ ('ACCOUNTING.VARIABILITY.order' | translate) | uppercase }}</th>
          <th class="text-sm w-130">{{ ('ACCOUNTING.VARIABILITY.account' | translate) | uppercase }}</th>
          <th class="text-sm w-130">{{ ('ACCOUNTING.VARIABILITY.accountName' | translate) | uppercase }}</th>
          <th class="text-sm w-70">{{ ('ACCOUNTING.VARIABILITY.variation' | translate) | uppercase }}</th>
          <th class="text-sm w-70">{{ ('TEMPLATE.operator' | translate) | uppercase }}</th>
          <th class="text-sm w-130">{{ ('PAYROLL_PREPARE.value' | translate) | uppercase }}</th>
          <th class="text-sm w-30">{{ ('MDU.action' | translate) | uppercase }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of accountingRuleSelection?.accountingRuleVariabilities; let i = index">
          <td><input type="text" [(ngModel)]="row.orderNumber" class="form-control"/></td>
          <td>
            <input type="text" [(ngModel)]="row.account" class="form-control"/>
          </td>
          <td>
            <input type="text" [(ngModel)]="row.accountName" class="form-control"/>
          </td>
          <td>
            <select [(ngModel)]="selectedRegContractIndex[i]"
                    class="form-control"
                    (ngModelChange)="onChangeTransId($event, row)">
              <option *ngFor="let option of paramOptions" [ngValue]="option">{{ (option.empZone?.transId || option.name) | translate }}</option>
            </select>
          </td>
          <td>
            <select [(ngModel)]="row.ruleOperator"
                    class="form-control"
                    [disabled]="isBooleanCriteria(selectedRegContractIndex[i])">
              <option *ngFor="let op of operatorOptions" [value]="op.value">{{ op.display }}</option>
            </select>
          </td>
          <td>
            <ng-container *ngIf="isBooleanCriteria(selectedRegContractIndex[i]); else notEqualsTemplate">
              <select [(ngModel)]="row.ruleValue"
                      class="form-control">
                <option *ngFor="let op of trueFalseOptions" [value]="op">{{ op }}</option>
              </select>
            </ng-container>
            <ng-template #notEqualsTemplate>
              <input type="text" [(ngModel)]="row.ruleValue" class="form-control"/>
            </ng-template>
          </td>
          <td>
            <button class="icon-button duplicate" (click)="duplicateRow(row)">
              <i class="fa fa-light fa-copy" aria-hidden="true"></i>
            </button>
            <button class="icon-button delete" (click)="deleteRow(row)">
              <i class="fa fa-light fa-trash-alt" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
        <tr class="static-row">
          <td></td>
          <td>{{ accountingRuleSelection?.account }}</td>
          <td>{{ accountingRuleSelection?.accountName }}</td>
          <td>{{ accountingRuleSelection?.accountType }}</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <!-- Empty row for adding a new entry -->
        <tr>
          <td colspan="6"></td>
          <td>
            <button class="add-button" (click)="addRow()"><i class="fa fa-plus-circle"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</gp-modal>

<!-- footer can't be in template -->
<footer *ngIf="!isStandAloneView" [gp-sticky]="'bottom,true'" [refreshOn]="dataLoaded"
        class="p-a footer-spacing"
        [ngClass]="{'dker': isAccountingRuleInitialised}">
  <ng-container *ngTemplateOutlet="footerContent"></ng-container>
</footer>

<ng-template #formTable>
  <form [formGroup]="accountingRuleForm" class="table-wrapper">
    <div [ngClass]="'isStandAloneView' ? 'gp-scroll-stand-alone' : 'gp-scroll-result'"
         class="accounting-mapping-table-container" role="region" aria-labelledby="caption"
         tabindex="0">
      <table aria-describedby="accountingRulesList"
             class="table table-striped accounting-mapping-table"
             id="accountingMappingTable">
        <thead class="headers white accounting-mapping-table-header-sticky-top">
          <tr role="row" *ngIf="isAccountingRuleInitialised">
            <th class="text-sm pointer" test-id="accountCol" scope="col">
              {{ 'ACCOUNTING.accounting_mapping.accounting_rule.account' | translate }}
            </th>
            <th class="text-sm pointer" test-id="accountNameCol" scope="col">
              {{ 'ORGANIZATION.name' | translate }}
            </th>
            <th class="text-sm pointer" test-id="accountTypeCol" scope="col">
              {{ 'ACCOUNTING.accounting_mapping.accounting_rule.account_type' | translate }}
            </th>
            <th class="text-sm pointer" test-id="debitColumn" scope="col">
              {{ 'POSTPAYROLL.ACCOUNTS.debit' | translate }}
            </th>
            <th class="text-sm pointer" test-id="creditColumn" scope="col">
              {{ 'POSTPAYROLL.ACCOUNTS.credit' | translate }}
            </th>
            <th class="text-sm pointer" test-id="complContractColumn" scope="col">
              {{ complementaryContractEntity?.transId | translate }}
            </th>
            <th class="text-sm pointer text-center" test-id="desactivationColumn" scope="col" *ngIf="!readOnly">
              {{ 'ACCOUNTING.accounting_mapping.accounting_rule.active' | translate }}
            </th>
            <th class="text-sm pointer text-center" test-id="desactivationColumn" scope="col" *ngIf="enableVariabilities && !readOnly">
              {{ 'ACCOUNTING.VARIABILITY.label' | translate }}
            </th>

            <th class="text-sm w-75 min-width-sm" scope="col" #unclickablezone>
              <!-- Actions -->
              <div class="pull-right">
                <button class="btn btn-sm btn-icon white"
                        type="button"
                        [class.active]="filtersVisible"
                        (click)="filtersVisible=!filtersVisible"
                        [tooltip]="'TOOLTIPS.filters' | translate"
                        [disabled]="!initialAccountingRules || !initialAccountingRules?.length">
                  <i class="fa fa-light fa-filter pointer" aria-hidden="true"></i>
                </button>
              </div>
            </th>
          </tr>

          <tr [formGroup]="filtersGroup" class="row" [attr.data-hidden]="!filtersVisible" #unclickablezone>
            <td>
              <input type="text"
                     class="form-control"
                     formControlName="account"/>
            </td>
            <td>
              <input type="text"
                     class="form-control"
                     formControlName="name"/>
            </td>
            <td>
              <input type="text"
                     class="form-control"
                     formControlName="accountType"/>
            </td>
            <td>
              <input type="text"
                     class="form-control"
                     formControlName="debitRules"/>
            </td>
            <td>
              <!-- Retro -->
              <input type="text"
                     class="form-control"
                     formControlName="creditRules"/>
            </td>
            <td>
              <input type="text"
                     class="form-control"
                     formControlName="complementaryContractName"/>
            </td>
            <td></td>
            <td *ngIf="enableVariabilities"></td>
            <td></td>
          </tr>
        </thead>

        <tbody formArrayName="accountingRules" #container>
          <tr *ngIf="!isAccountingRuleInitialised || isAccountingRuleLoading || executingActions">
            <td [attr.colspan]="colSpanTable" class="text-center p-t-lg p-b-lg">
              <em class="fa fa-light fa-spinner fa-spin spinner"></em>
            </td>
          </tr>
          <tr (click)="editCell(group.value, formIndex)"
              *ngFor="let group of accountingRules.controls  | slice: getPaginationStartIndex() : getPaginationEndIndex(); let formIndex=index"
              [formGroupName]="getActualIndexBasedOnCurrentPage(formIndex)"
              [ngClass]="{'table-danger': group.invalid}">
            <td (click)="editCell(group.value, formIndex)" class="account-col">
              <div *ngIf="!group.get('editMode').value" class="account-col">
                {{group.get('account').value}}
                <span *ngIf="!group.get('account').value">-</span>
              </div>

              <div [attr.data-hidden]="!group.get('editMode').value" class="account-col">
                <input [attr.test-id]="'account' + getActualIndexBasedOnCurrentPage(formIndex)"
                       class="form-control"
                       formControlName="account"
                       type="text"
                       [id]="'account' + getActualIndexBasedOnCurrentPage(formIndex)"
                       #accountingRuleAccountInput>
                <ul class="error-list"
                    [attr.data-hidden]="group.get('account').valid">
                  <li *ngIf="group.get('account').hasError('duplicateValue')">
                    {{'ACCOUNTING.ACCOUNTING_PLAN_MAPPING.duplicate_account_number_error' | translate}}
                  </li>
                </ul>
              </div>
            </td>
            <td (click)="editCell(group.value, formIndex)" class="account-name-col">
              <div *ngIf="!group.get('editMode').value" class="account-name-col action-label">
                {{group.get('accountName').value}}
                <span *ngIf="!group.get('accountName').value">-</span>
              </div>
              <div *ngIf="group.get('editMode').value" class="account-name-col table-cell">
                <input [attr.test-id]="'accountName' +  getActualIndexBasedOnCurrentPage(formIndex)"
                       class="form-control"
                       formControlName="accountName"
                       type="text">
                <ul [attr.data-hidden]="group.get('accountName').valid" class="error-list">
                </ul>
              </div>
            </td>
            <td (click)="editCell(group.value, formIndex)" class="account-type-col">
              <div *ngIf="!group.get('editMode').value" class="account-type-col action-label">
                {{group.get('accountType').value}}
                <span *ngIf="!group.get('accountType').value">-</span>
              </div>
              <div *ngIf="group.get('editMode').value" class="account-type-col table-cell">
                <input [attr.test-id]="'accountType' +  getActualIndexBasedOnCurrentPage(formIndex)"
                       class="form-control"
                       formControlName="accountType"
                       type="text">
              </div>
            </td>
            <td (click)="editCell(group.value, formIndex)" class="debit-col">
              <gp-chips [placeholder]="'ACCOUNTING.ACCOUNTING_PLAN_MAPPING.choose_debit_rules'" [withAutocomplete]="true"
                        [formControlName]="'debitRules'"
                        [canAddNewTags]="true"
                        [showTooltip]="true"
                        [identifyBy]="'value'"
                        [displayBy]="'display'"
                        [readOnly]="!group.get('editMode').value"
                        (filterOptions)="filterDebitRulesBasedOnInput($event)">
                <gp-chips-option *ngFor="let option of payArraysForDebitRules" [ngValue]="option"></gp-chips-option>
              </gp-chips>
            </td>
            <td (click)="editCell(group.value, formIndex)" class="credit-col">
              <gp-chips [placeholder]="'ACCOUNTING.ACCOUNTING_PLAN_MAPPING.choose_credit_rules'" [withAutocomplete]="true"
                        [formControlName]="'creditRules'"
                        [readOnly]="!group.get('editMode').value"
                        [canAddNewTags]="true"
                        [showTooltip]="true"
                        [identifyBy]="'value'"
                        [displayBy]="'display'"
                        (filterOptions)="filterCreditRulesBasedOnInput($event)">
                <gp-chips-option *ngFor="let option of payArraysForCreditRules" [ngValue]="option"></gp-chips-option>
              </gp-chips>
            </td>
            <td (click)="editCell(group.value, formIndex)" class="complementary-contract-col"
                [attr.colspan]="readOnly? 2 : 0">
              <div class="relative-scroll">
                <gp-tree-select *ngIf="group.get('editMode').value"
                                class="form-control"
                                [isSorted]="true"
                                [clearAfterSelection]="true"
                                (elementSelected)="onTreeSelection(group.get('complementaryContractsList'), $event)"
                                [tree]="complementaryContractTree">
                </gp-tree-select>
              </div>
              <gp-chips [withAutocomplete]="true"
                        [formControlName]="'complementaryContractsList'"
                        [canAddNewTags]="false"
                        [externalInput]="true"
                        [readOnly]="!group.get('editMode').value"
                        [identifyBy]="'id'"
                        [showTooltip]="true"
                        [displayBy]="'name'">
                <gp-chips-option *ngFor="let option of complementaryContractList" [ngValue]="option"></gp-chips-option>
              </gp-chips>
            </td>
            <td (click)="editCell(group.value,formIndex)" [attr.colspan]="readOnly? 2 : 0" *ngIf="!readOnly"
                class="rule-active-col">
              <div class="form-group col-xs-2">
                <label class="ui-switch">
                  <input type="checkbox" formControlName="active" (click)="toggleValue(group.value, formIndex)">
                  <em></em>
                </label>
              </div>
            </td>

            <td *ngIf="enableVariabilities">
              <div class="center-buttons">
                <button
                  class="btn-generate btn btn-xs btn-outline action-btn inactive"
                  [ngClass]="group.value.accountingRuleVariabilities?.length > 0
                    ? ['b-success', 'text-success']
                    : ['b-danger', 'text-danger']"
                  (click)="openVariabilitiesEditor($event, group.value)"
                  [disabled]="this.isSelectedRegContractIndexLoading"
                  [tooltip]="this.isSelectedRegContractIndexLoading
                    ? ('ACCOUNTING.VARIABILITY.loading' | translate)
                    : null"
                >
                  {{ group.value.accountingRuleVariabilities?.length > 0 ? ('COMMON.active' | translate) : ('COMMON.inactive' | translate) }}
                </button>
              </div>
            </td>

            <td *ngIf="!readOnly" class="action-col">
              <div class="btn-bar-wrapper pull-right" [ngClass]="{'rule-space': !isStandAloneView}">
                <div class="btn-bar btn-bar-sm">
                  <button (click)="copyAccountingRule($event, group.value, formIndex)"
                          class="btn btn-sm btn-icon white"
                          container="body"
                          placement="left"
                          tooltip="{{ 'TOOLTIPS.clone_entry' | translate }}"
                          [disabled]="group.invalid"
                          type="button">
                    <i aria-hidden="true" class="far fa-clone"></i>
                  </button>
                  <button (click)="deleteAccountingRules($event, group.value)"
                          class="btn btn-sm btn-icon white"
                          container="body"
                          placement="left"
                          tooltip="{{ 'TOOLTIPS.delete_entry' | translate }}"
                          type="button">
                    <i aria-hidden="true" class="fa fa-light fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
  <gp-illustrated-message [width]="'50%'"
                          *ngIf="!isAccountingRuleLoading && !initialAccountingRules?.length && !accountingRules?.length"
                          [text]="'ACCOUNTINGPLAN.no_accountingRule'">
  </gp-illustrated-message>
</ng-template>
<ng-template #accountingMappingContentStandAlone>
  <div class="main-button-bar">
    <a [routerLink]="['/configuration/accounting']">
      <button class="btn dark-white p-x-md light-border"
              type="button">
        {{ 'FORMS.back' | translate }}
      </button>
    </a>
    <div class="pull-right">
      <button (click)="addNewAccountingRule()"
              class="btn white no-borders pull-right btn-add button-spacing"
              placement="left"
              [disabled]="isAccountingRuleLoading || executingActions || ! formContainsEditableRows()"
              tooltip="{{ 'TOOLTIPS.add_entry' | translate }}"
              type="button" #unClickableZone>
        <i aria-hidden="true" class="fa fa-light fa-plus"></i>
      </button>
      <button (click)="confirmResetFormTemplate()"
              [disabled]="!canCancelBtnBeEnabled()"
              class="btn dark-white p-x-md button-spacing light-border"
              type="button">
        {{ 'FORMS.cancel' | translate }}
      </button>
      <button (click)="submitForm()"
              class="btn btn-primary p-x-md button-spacing"
              test-id="modalSubmitButton"
              [disabled]="!canSaveBtnBeEnabled()"
              type="button">
        {{ 'FORMS.save' | translate }}
      </button>
    </div>
  </div>

  <ng-container *ngTemplateOutlet="formTable"></ng-container>
</ng-template>

<!-- Integrated view (for modal or embedded view) -->
<ng-template #accountingMappingContent>
  <div *ngIf="!readOnly" class="card-dated-controls pull-right no-padding">
    <button (click)="addNewAccountingRule()"
            class="btn white no-borders pull-right btn-add"
            placement="left"
            [disabled]="isAccountingRuleLoading || executingActions || ! formContainsEditableRows()"
            tooltip="{{ 'TOOLTIPS.add_entry' | translate }}"
            type="button" #unClickableZone>
      <i aria-hidden="true" class="fa fa-light fa-plus"></i>
    </button>
  </div>
  <ng-container *ngTemplateOutlet="formTable"></ng-container>
</ng-template>

<ng-template #footerContent>
  <div class="row" *ngIf="isAccountingRuleInitialised">
    <div class="col-sm-12 text-center text-center-xs">
      <ul class="pagination pagination-sm gp-pagination m-a-0" [class.gp-pagination-hidden]="!pagination.hasMultiplePages()">
        <li [ngClass]="{disabled: !pagination.hasPrevious()}" class="page-item">
          <a (click)="pagination.hasPrevious() && pagination.first()" class="page-link">
            <i aria-hidden="true" class="fa fa-light fa-angle-double-left"></i>
          </a>
        </li>
        <li [ngClass]="{disabled: !pagination.hasPrevious()}" class="page-item">
          <a (click)="pagination.hasPrevious() && pagination.previous()" class="page-link">
            <i aria-hidden="true" class="fa fa-light fa-angle-left"></i>
          </a>
        </li>
        <li *ngFor="let page of pagination.pages()" class="page-item"
            [ngClass]="{active: page === pagination.currentPage.number + 1, disabled: page < 1}">
          <a *ngIf="page > 0" (click)="pagination.goToPage(page - 1)" class="page-link">{{ page }}</a>
          <a *ngIf="page < 1" class="page-link default-cursor">…</a>
        </li>
        <li [ngClass]="{disabled: !pagination.hasNext()}" class="page-item">
          <a (click)="pagination.hasNext() && pagination.next()" class="page-link">
            <i aria-hidden="true" class="fa fa-light fa-angle-right"></i>
          </a>
        </li>
        <li [ngClass]="{disabled: !pagination.hasNext()}" class="page-item">
          <a (click)="pagination.hasNext() && pagination.last()" class="page-link">
            <i aria-hidden="true" class="fa fa-light fa-angle-double-right"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</ng-template>
